import { render } from "./FpAsideItem.vue?vue&type=template&id=8529395c&lang=pug"
import script from "./FpAsideItem.vue?vue&type=script&lang=js"
export * from "./FpAsideItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__